var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.144 5.067C4.052 5.613 3.7 6.21 3.7 6.617c0 .406.352 1.003 1.444 1.55 1.04.52 2.539.866 4.24.866 1.7 0 3.198-.346 4.24-.867 1.091-.546 1.443-1.143 1.443-1.55 0-.406-.352-1.003-1.444-1.549-1.04-.52-2.539-.867-4.24-.867-1.7 0-3.198.347-4.24.867M3.7 9.293q.329.217.683.394c1.324.662 3.093 1.047 5 1.047s3.677-.385 5-1.047c1.273-.636 2.384-1.673 2.384-3.07 0-1.398-1.11-2.434-2.383-3.07-1.324-.662-3.093-1.047-5-1.047s-3.677.385-5 1.047C3.11 4.183 2 5.219 2 6.617v8.167c0 1.397 1.11 2.433 2.383 3.07 1.324.662 3.093 1.046 5 1.046a.85.85 0 1 0 0-1.7c-1.7 0-3.198-.346-4.24-.867-1.091-.546-1.443-1.143-1.443-1.55v-1.405c.57.376 1.25.682 1.991.912.44.136.908.248 1.396.333a.85.85 0 0 0 .292-1.675 10 10 0 0 1-1.184-.282c-.852-.264-1.508-.617-1.933-.992-.426-.373-.562-.71-.562-.974z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.384 13.764C3.11 13.128 2 12.091 2 10.694h1.7c0 .407.352 1.004 1.444 1.55 1.04.52 2.539.867 4.24.867a.85.85 0 1 1 0 1.7c-1.908 0-3.677-.385-5-1.047"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.1 11.74a4.15 4.15 0 1 0 0 8.3 4.15 4.15 0 0 0 0-8.3m-5.85 4.15a5.85 5.85 0 1 1 11.7 0 5.85 5.85 0 0 1-11.7 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.701 13.99a.85.85 0 0 1 0 1.201l-3 3a.85.85 0 0 1-1.202 0l-1.5-1.5a.85.85 0 1 1 1.202-1.202l.899.9 2.399-2.4a.85.85 0 0 1 1.202 0",
  clipRule: "evenodd"
}))));
export default SvgPay;